<template>
  <div>
    <page-title>Shippers Report</page-title>SHIPPERS REPORT
  </div>
</template>

<script>
export default {
  name: "ShippersReport",

  data() {
    return {};
  }
};
</script>
<style scoped="">
</style>


